// check availability of window storage - see node module storage-available.js
export default function storageAvailable(type: string) {
  try {
    const storage = window[type],
      x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return false
  }
}
